import {combineReducers} from 'redux';

import { AUTH_BASE } from './Auth/constants';
import authState from './Auth/reducers';
import activityState from './Activity/reducers';
import exerciseState from './Exercise/reducers';
import classState from './Class/reducers';
import classFormState from './ClassForm/reducers';
import companyState from './Company/reducers';
import individualCoachState from './IndividualCoach/reducers';
import individualCoachFormState from './IndividualCoachForm/reducers';
import programState from './Program/reducers';
import programFormState from './ProgramForm/reducers';
import settingsState from './Settings/reducers';
import resourceState from './Resource/reducers';
import trainerState from './Trainer/reducers';
import activityFormState from './ActivityForm/reducers';
import exerciseFormState from './ExerciseForm/reducers';
import mediaLibraryState from './MediaLibrary/reducers';
import securityState from './Security/reducers';
import channelFormState from './ChannelForm/reducers';
import dashboardState from './Dashboard/reducers';
import globalUIState from './GlobalUI/reducers';
import uploadQueueState from './UploadQueue/reducers';
import welcomeVideoState from './WelcomeVideo/reducers';

const appReducer = combineReducers({
  authState,
  activityState,
  exerciseState,
  classState,
  classFormState,
  companyState,
  individualCoachState,
  individualCoachFormState,
  programState,
  programFormState,
  settingsState,
  resourceState,
  trainerState,
  activityFormState,
  exerciseFormState,
  mediaLibraryState,
  securityState,
  channelFormState,
  dashboardState,
  globalUIState,
  uploadQueueState,
  welcomeVideoState
});

const rootReducer = (state, action) => {
  if (action.type === AUTH_BASE) {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;
